import CollectionSearchResults from './CollectionSearchResults';

export default CollectionSearchResults;
